// extracted by mini-css-extract-plugin
module.exports = {"textClass":"text_textClass__1e77o","xs":"text_xs__fAKxN","sm":"text_sm__vr_LA","md":"text_md__kZtNb","lg":"text_lg__j5tlM"};